import React from 'react'
import "./ExperienceCard.css"

function ExperienceCard({ companyName, designation, statements, iconImages }) {
  return (
    <div className='ex_card_container'>
      <div className=' flex flex-wrap place-self-center border-primary-800 border rounded-md'>
        <p className='my-10 mb-4 text-3xl px-5'>{companyName}</p>
        <p className='text-xl mb-3 text-gray-400 px-5 '>Designation: {designation}</p>
        {statements.map((value, key) => (
            <p className='text-lg text-gray-400 px-5'>{value}</p>
        ))}
        <div className='mx-auto'>
        <p className='text-2xl text-center mt-5 mb-3 text-gray-400'>Tech Used</p>
        <div className='ex_card_icon_images_container'>
            {iconImages.map((value, key) => (
                <img src={value} className="tech-icon" />
            ))}</div></div>
        </div>
    </div>
  )
}

export default ExperienceCard